import { render, staticRenderFns } from "./ProcessProportion.vue?vue&type=template&id=2616ddb1&scoped=true"
import script from "./ProcessProportion.vue?vue&type=script&lang=js"
export * from "./ProcessProportion.vue?vue&type=script&lang=js"
import style0 from "./ProcessProportion.vue?vue&type=style&index=0&id=2616ddb1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2616ddb1",
  null
  
)

export default component.exports